<template>
  <div>
    <div class="bg-green-gray px-3 py-2 rounded-top border-bottom">
      <medical-plan-badges
        :has-consent="value.hasConsent"
        :has-medical-plan="value.hasMedicalPlan"
      />
    </div>
    <custom-callout
      controlled
      has-toggle
      :opened="value.opened"
      @click:open="toggle()"
    >
      <div class="row d-flex align-items-center py-2 pr-3">
        <div class="col-12 col-md">
          <div class="data-name">Estudiante:</div>
          <div>
            {{ value.student?.id | empty }} -
            {{ value.student?.name | empty }}
          </div>
        </div>

        <div class="col-12 col-md">
          <div class="data-name">Servicio:</div>
          <div>{{ value.disciplineType?.name | empty }}</div>
        </div>

        <div class="col-12 col-md">
          <div class="data-name">Lugar de Servicio:</div>
          <div>{{ value.location?.name | empty }}</div>
        </div>

        <div class="col-12 col-md-2 d-flex justify-content-end">
          <drop-down :items="actions" />
        </div>

        <div class="w-100 px-3">
          <hr />
        </div>

        <div class="col-12 col-md">
          <div class="data-name">Cantidad de Servicios:</div>
          <div>{{ value.serviceCount }}</div>
        </div>

        <div class="col-12 col-md">
          <div class="data-name">Proveedor:</div>
          <div>{{ value.company?.name | empty }}</div>
        </div>

        <div class="col-12 col-md">
          <div class="data-name">Especialista:</div>
          <div>{{ value.specialist?.name | empty }}</div>
        </div>
        <div class="col-12 col-md-2" />
      </div>
      <template #edition>
        <div class="bg-secondary-3 p-2">
          <!-- acción de información adicional -->
          <div v-if="isAdditionalInfo" class="bg-white p-3 rounded mr-0 ml-0">
            <div class="row">
              <div class="col-12 mb-3">
                <i class="fas fa-info-circle text-orange" />
                <b class="ml-2">
                  Información Adicional
                </b>
              </div>
              <div class="col-12 col-md">
                <div class="data-name">Tipo de Lugar:</div>
                <div>{{ value.locationType?.name | empty }}</div>
              </div>

              <div class="col-12 col-md">
                <div class="data-name">Modalidad:</div>
                <div>{{ value.modalityType?.name | empty }}</div>
              </div>

              <div class="col-12 col-md">
                <div class="data-name">Frecuencia:</div>
                <div>{{ value.frequencyType?.name | empty }}</div>
              </div>

              <div class="col-12 col-md">
                <div class="data-name">Duración:</div>
                <div>{{ value.therapyDuration?.name | empty }}</div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </custom-callout>
  </div>
</template>

<script>
//mixins
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

//components
import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';

//local components
import MedicalPlanBadges from './MedicalPlanBadges.vue';

import moment from 'moment';

export default {
  name: 'StudentResultRow',
  components: {
    CustomCallout,
    DropDown,
    MedicalPlanBadges,
  },
  filters: {
    time(value) {
      return value ? moment(value, 'HH:mm:ss').format('hh:mm A') : '-';
    },
  },
  mixins: [alertMixin],

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      section: null,
    };
  },
  computed: {
    sections() {
      return Object.freeze({
        AdditionalInfo: 0,
        StudentHistory: 1,
      });
    },
    actions() {
      return [
        {
          name: 'additionalInformation',
          label: 'Información Adicional',
          icon: 'fas fa-info-circle text-green',
          click: () => this.toggle(this.sections.AdditionalInfo, false),
        },
        {
          name: 'services',
          label: 'Ver Servicios',
          icon: 'fas fa-calendar text-green',
          click: () => {
            const payload = {
              studentSieId: String(this.value.student?.id),
              isAdvancedSearch: false,
            };
            this.$emit('view-services', payload);
          },
        },
      ];
    },
    isAdditionalInfo() {
      return this.section === this.sections.AdditionalInfo;
    },
  },
  methods: {
    toggle(section, toggle = true) {
      this.section = section ?? this.sections.AdditionalInfo;
      if (toggle) this.value.opened = !this.value.opened;
      else this.value.opened = true;
    },
    cancel() {
      this.section = null;
      this.value.opened = false;
    },
  },
};
</script>

<style scoped>
.bg-green-gray {
  background-color: #ebf1ee !important;
}
</style>
